import { useMatch } from 'react-router-dom';
import { DISH_ROUTE, MENU_ROUTE } from '../../common/constants/routes';

// The menu the guest is actually looking at, for components mounted
// outside the route tree. Null on every other URL.
export function useRouteMenuId(): number | null {
    const menuMatch = useMatch(MENU_ROUTE);
    const dishMatch = useMatch(DISH_ROUTE);
    const id = menuMatch?.params.id ?? dishMatch?.params.id;
    if (!id) return null;
    const menuId = Number(id);
    return Number.isInteger(menuId) && menuId > 0 ? menuId : null;
}
